<wr-base-dialog
  [header]="header ?? 'Änderungen nicht gespeichert'"
  [status]="status"
  [submitText]="submitText ?? 'Bestätigen'"
  [cancelText]="cancelText ?? 'Zurück'">

  @if (message) {
    {{ message }}
  } @else {
    Achtung, alle Änderungen gehen verloren. Sind Sie sicher, dass Sie die Bearbeitung abbrechen möchten?
  }
</wr-base-dialog>
